import axios from 'axios';
import React from 'react'

import { BASE_URL } from '../../inc/constants';
import {fetchFormStarted,fetchFormStartedError, fetchFormFieldsSuccess, fetchFormDataSuccess,fetchFormInstancesSuccess, putFormData, postFormData} from './actions';
import { Form } from './types';
import { useHistory } from 'react-router';
import { AppState } from '..';
import { handleCache } from '../base/functions';
export const fetchFormFields = (formId: number) => {
    return (dispatch: any,getState: any) =>  {
        if(formId === undefined || formId === null) return;

        let state:AppState = getState();

        let isFormFieldAvailable = false;
        if(state.forms.forms.length != 0) {
            let formIndex = finder(formId,state.forms.forms);
            if(formIndex != -1) {
                isFormFieldAvailable = state.forms.forms[formIndex].formFields.length != 0
            }
        }

        if(!isFormFieldAvailable) {
            dispatch(fetchFormStarted());
            const headers = {Authorization: `token ${state.base.token}`};
            axios.get(`${BASE_URL}/forms/${formId}/`,{headers})
            .then(res => {
                dispatch(fetchFormFieldsSuccess(formId,res.data.title,res.data.fields));
            })
            .catch(err => {
                dispatch(fetchFormStartedError(err));
                handleCache(dispatch,err);
            });
        }
    };
};

export const fetchFormData = (id: number,formId: number) => {
    return (dispatch: any,getState: any) =>  {
        if(formId === undefined || formId === null) return;
        if(id === undefined || id === null) return;

        let state:AppState = getState();

        let isFormDataAvailable = false;
        if(state.forms.forms.length != 0) {
            let formIndex = finder(formId,state.forms.forms);
            if(formIndex != -1) {
                let formDataIndex = -1;
                formDataIndex = finder(id,state.forms.forms[formIndex].formDatas);
                if(formDataIndex != -1) {
                    isFormDataAvailable = state.forms.forms[formIndex].formDatas[formDataIndex].items.length != 0
                }
            }
        }
        
        if(!isFormDataAvailable) {
            dispatch(fetchFormStarted());
            const headers = {Authorization: `token ${state.base.token}`};
            axios.get(`${BASE_URL}/form-instances/${id}/`,{headers})
            .then(res => {
                dispatch(fetchFormDataSuccess(formId,id,res.data.title,res.data.fields, res.data.signature));
            })
            .catch(err => {
                dispatch(fetchFormStartedError(err));
                handleCache(dispatch,err);
            });
        }

    };
};

export const fetchFormInstances = (formId: number) => {
    return (dispatch: any,getState: any) =>  {
        if(formId === undefined || formId === null) return;

        let state:AppState = getState();

        let isFormInstancesAvailable = false;
        if(state.forms.forms.length != 0) {
            let formIndex = finder(formId,state.forms.forms);
            if(formIndex != -1) {
                isFormInstancesAvailable = state.forms.forms[formIndex].dataSource.length !== 0 && state.forms.forms[formIndex].columns.length !== 0
            }
        }

        if(!isFormInstancesAvailable) {
            dispatch(fetchFormStarted());
            const headers = {Authorization: `token ${state.base.token}`};
            axios.get(`${BASE_URL}/forms/${formId}/instances/`,{headers})
            .then(res => {
                dispatch(fetchFormInstancesSuccess(formId,res.data.title, res.data.description,res.data.dataSource,res.data.columns));
            })
            .catch(err => {
                dispatch(fetchFormStartedError(err));
                handleCache(dispatch,err);
            });
        }
    };
};

export const putFormDataItem = (id: number,formId: number,formData: any,then?: Function) => {
    return (dispatch: any,getState: any) =>  {

        dispatch(fetchFormStarted());

        let state:AppState = getState();

        const headers = {Authorization: `token ${state.base.token}`};
        axios.put(`${BASE_URL}/form-instances/${id}/`,formData,{headers})
        .then(res => {
            dispatch(putFormData(id,formId,formData));
        })
        .then(()=>{
            if(then) {
                then();
            }
        })
        .catch(err => {
            dispatch(fetchFormStartedError(err));
            handleCache(dispatch,err);
        });

    };
};

export const postFormDataItem = (formId: number,formData: any,then?: Function) => {
    return (dispatch: any,getState: any) =>  {
        dispatch(fetchFormStarted());

        let state:AppState = getState();

        const headers = {Authorization: `token ${state.base.token}`};
        axios.post(`${BASE_URL}/forms/${formId}/instances/`,formData,{headers})
        .then(res => {
            dispatch(postFormData(formId,formData));
        })
        .then(()=>{
            if(then) {
                then();
            }
        })
        .catch(err => {
            dispatch(fetchFormStartedError(err));
            handleCache(dispatch,err);
        });

    };
};

//externals
export function formCreator(id: number,title: string = "بدون عنوان", description: string="") {
    let form: Form = {
        id,
        title,
        description,
        formFields:[],
        formDatas: [],
        columns: [],
        dataSource: []
    }
    return form
}
export function finder(id: any,data: any[]) {
    return data.findIndex((v,k)=>v.id==id)
}